var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_Info",
    transform: "translate(-485.5 -171.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(484.232 170.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3208",
    "data-name": "Group 3208",
    transform: "translate(1.413 1.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M5,0A5,5,0,1,1,0,5,5,5,0,0,1,5,0Z",
    transform: "translate(0.355 0.355)",
    fill: "none",
    stroke: "#e24d49",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    y1: 3,
    transform: "translate(5.355 5.355)",
    fill: "none",
    stroke: "#e24d49",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    transform: "translate(5.355 3.355)",
    fill: "none",
    stroke: "#e24d49",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfoIcon);
export default __webpack_public_path__ + "static/media/error-info-icon.84325c26df53e8d8f6cfef69ffa16e8d.svg";
export { ForwardRef as ReactComponent };